export const SHARED_TEXT_ZONE = {

  'COLLABORATIVE_EDITING': 'Collaborative editor',
  'COLLABORATIVE_EDITING_ERROR': 'Collaborative editing service is currently unavailable.'

};
